import React, { useEffect, useState } from "react";
import { SectionTitle } from "./_components/SectionTitle";
import { CustomAccordion } from "./_components/CustomAccordion";
import {
  Breadcrumb,
  BreadcrumbEllipsis,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "src/components/ui/breadcrumb";
import { Link } from "react-router-dom";
import { Card } from "../../components/ui/card";
import { AnimatePresence, motion } from "framer-motion";
import { SearchIcon } from "lucide-react";
import { Input } from "../../components/ui/input";
import TeacherCard from "./_components/TeacherCard";
import { BaseUrlApi, ErrorMessage } from "../../lib/api";
import { toast } from "sonner";
import axios from "axios";

export default function MainTeachers() {
  const [searchTerm, setSearchTerm] = useState("");
  const [teachers, setTeachers] = useState([]);
  const [loadingTeachers, setLoadingTeachers] = useState(true);

  const fetchTeachers = async () => {
    try {
      const { data } = await axios.get(`${BaseUrlApi}/users`);
      const allTeachers = data.data.filter((user) => user?.role === "teacher");
      setTeachers(allTeachers);
    } catch (error) {
      const result = ErrorMessage(error);
      if (typeof result !== "object") {
        toast("Error", { description: result });
      }
    } finally {
      setLoadingTeachers(false);
    }
  };

  useEffect(() => {
    fetchTeachers();
  }, []);

  // 🔍 Search logic
  const filteredTeachers = teachers.filter((teacher) =>
    teacher.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="space-y-20 max-w-7xl mx-auto px-4 mt-14">
      <div className="space-y-6">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/">الصفحة الرئيسية</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage className="font-semibold">
                المعلمون
              </BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        <div className="space-y-4 text-center">
          <SectionTitle title="المعلمون" />
          <p className="text-lg text-muted-foreground">
            نخبة من المعلمين المؤهلين، مستعدون لإرشادك في رحلتك التعليمية بخبرة
            وشغف.
          </p>
        </div>
      </div>

      <div className="space-y-6">
        {/* search */}
        <div className="flex items-center gap-2 border rounded-full px-4 py-1 w-full md:w-1/3">
          <SearchIcon className="w-5 h-5" />
          <input
            className="bg-transparent outline-none border-none py-1 flex-1 p-0 ring-0"
            placeholder="ابحث في المعلمون..."
            type="search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {/* filtered results */}
        <TeacherCard teachers={filteredTeachers} loading={loadingTeachers} />
      </div>
    </div>
  );
}
